// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"308":"continueonpc","352":"onboarding","530":"simulation","817":"finished","962":"home"}[chunkId] + "." + {"308":"69029066","352":"7aa2623b","530":"ad858f97","817":"ebbdee0a","962":"efd97df3"}[chunkId] + ".css";
};